// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3nXIt","addWidgetButton":"Header_addWidgetButton__2rPyt","dashboardTabs":"Header_dashboardTabs__oFmWm","active":"Header_active__2aNvh"};